<template>
  <div class="business">
    <menuBox :step="3"></menuBox>
    <div class="top-box">
      <div class="top-title">Perekrutan Sukarelawan</div>
      <div class="top-content">
        PT JASINDO CITRA MAJU / Perekrutan Sukarelawan
      </div>
    </div>
    <div class="privacy-box">
      <div class="title">Pengumuman Rekrutmen Relawan</div>

      Di PT Jasindo Citra Maju, kami percaya bahwa setiap orang mempunyai
      kemampuan untuk membawa perubahan positif bagi masyarakat. Kami mencari
      sukarelawan yang bersemangat dan termotivasi untuk bergabung dalam misi
      kami dalam mempromosikan kesehatan dan kesejahteraan komunitas kami. Jika
      Anda ingin terlibat dalam pekerjaan yang bermakna dan bersedia
      berkontribusi untuk meningkatkan kehidupan orang lain, Andalah yang kami
      butuhkan! <br />

      Peran sukarelawan:<br />

      Advokat Kesehatan Masyarakat: Berpartisipasi dalam kampanye kesehatan
      masyarakat kami dan membantu meningkatkan kesadaran masyarakat terhadap
      masalah kesehatan.<br />
      Asisten Pendidikan dan Pelatihan: Mendukung program pendidikan kami,
      termasuk pendidikan dasar dan pelatihan keterampilan untuk anak-anak dan
      orang dewasa.<br />
      Penyelenggara Acara: Membantu perencanaan dan pelaksanaan berbagai acara
      komunitas dan penggalangan dana.<br />
      Dukungan Administratif: Memberikan dukungan administratif dan organisasi
      di kantor kami.<br />
      Asisten Program Bantuan Medis Anak: Memberikan dukungan dalam Program
      Bantuan Medis Anak kami, membantu menggalang dana dan mengoordinasikan
      sumber daya.<br />
      kami menyediakan:<br />

      Peluang pelatihan dan pengembangan untuk mengembangkan keterampilan
      Anda.<br />
      Peluang untuk pertumbuhan pribadi dan pengembangan profesional.<br />
      Bekerjalah dengan orang-orang yang berpikiran sama dan bangun jaringan
      yang berharga.<br />
      Peluang untuk mendapatkan pengetahuan mendalam tentang operasi nirlaba dan
      pengembangan masyarakat.<br />
      Relawan yang ideal harus memiliki:<br />

      Bergairah tentang kesejahteraan sosial dan kesehatan masyarakat.<br />
      Keterampilan komunikasi yang baik dan semangat kerja sama tim.<br />
      Kemampuan untuk secara teratur berpartisipasi dalam kegiatan sukarela.<br />
      Positif dan optimis, mau mempelajari keterampilan baru.<br />
      bagaimana menerapkan:<br />
      Silakan kirimkan resume dan surat lamaran singkat Anda ke alamat email
      kami [alamat email]. Dalam surat lamaran Anda, harap jelaskan peran
      sukarelawan yang ingin Anda ikuti dan mengapa menurut Anda Anda cocok
      untuk peran tersebut.<br />

      tanggal habis tempo:<br />
      Kami menerima lamaran sepanjang tahun, namun menganjurkan Anda untuk
      mengirimkan lamaran Anda lebih awal sehingga kami dapat memprosesnya
      segera.<br />

      Di PT Jasindo Citra Maju, kami percaya bahwa setiap orang dapat menjadi
      kekuatan untuk melakukan perubahan. Bergabunglah dengan tim sukarelawan
      kami dan bersama-sama bangun komunitas yang lebih sehat dan bahagia!
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    aboutUs() {
      this.$router.push({ path: "aboutUs" });
    },
    submit() {
      alert("Success");
    },
  },
};
</script>
<style lang="less" scoped>
.top-box {
  height: 60px;
  background: #ce3723;
  padding: 0 360px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .top-title {
    font-size: 24px;
    font-family: Inter, Inter;
    font-weight: normal;
    color: #ffffff;
    line-height: 29px;
  }
  .top-content {
    font-size: 14px;
    font-family: Inter, Inter;
    font-weight: 400;
    color: #ffffff;
    line-height: 17px;
  }
}
.title-box {
  background-image: url(../assets/about-1.png);
  width: 100%;
  height: 320px;
  background-size: 100% 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 64px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
}
.privacy-box {
  padding: 80px 360px;
  font-size: 20px;
font-family: PingFang SC, PingFang SC;
font-weight: 400;
color: #000000;
line-height: 40px;
  .title {
    font-size: 32px;
    font-family: Inter, Inter;
    font-weight: normal;
    color: #1e1e1e;
    line-height: 38px;
    text-align: center;
    margin-bottom: 32px;
  }
}
</style>
